import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  selector: 'lib-date-input',
  imports: [NgClass, ReactiveFormsModule, MatDatepickerModule],
  templateUrl: './date-input.html',
  styleUrl: './date-input.css',
  providers: [provideNativeDateAdapter()],
})
export class DateInput {
  @Input('label') label = '';
  @Input('labelClass') labelClass = '';
  @Input('inputClass') inputClass = '';
  @Input('placeholder') placeholder = '';
  @Input({ alias: 'errorMessage' }) errorMessage?: string;
  @Input({ alias: 'useDefaultError', transform: booleanAttribute })
  useDefaultError: boolean = true;
  @Input('minDate') minDate: Date | undefined;
  @Input('maxDate') maxDate: Date | undefined;
  // amazonq-ignore-next-line
  @Input({ alias: 'control' }) control!: FormControl;

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (this.useDefaultError && (changes['label'] || !this.errorMessage)) {
        this.errorMessage = `Invalid ${
          this.label || 'input'
        }. Please check your entries and try again.`;
      }
    } catch (error) {
      console.error('Error in DateInput ngOnChanges:', error);
    }
  }
}
